const doc = [({"se":({"js":({"components":({"user":({"unicorn":({"top_bar":({})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;